import { ComponentSettingKey } from '../../types'
import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const PricingDesignSettings = {
  // spacing
  'pricing-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  // alignment
  'pricing-design-billing-toggle-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'pricing-design-layout': {
    phone: 'table',
    'phone-landscape': 'table',
    tablet: 'table',
    'tablet-landscape': 'table',
    desktop: 'table',
    tv: 'table',
  },
  'pricing-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'pricing-design-border': {
    dark: 'primary-70',
    light: 'primary-70',
  },
  'pricing-design-header-border': {
    dark: 'primary-80',
    light: 'primary-80',
  },
  'pricing-design-accent-color': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'pricing-design-popular-badge-background': {
    dark: 'extended-1',
    light: 'extended-1',
  },
  'pricing-design-popular-badge-text': {
    dark: 'primary-0',
    light: 'primary-100',
  },
  'pricing-design-icon-success': {
    dark: 'extended-6',
    light: 'primary-10',
  },
  'pricing-design-icon-error': {
    dark: 'extended-7',
    light: 'extended-7',
  },
  'pricing-design-button-primary': {
    dark: 'extended-10',
    light: 'extended-10',
  },
  [ComponentSettingKey.PricingDesignBillingToggleBackground]: {
    dark: 'extended-10',
    light: 'extended-10',
  },
  [ComponentSettingKey.PricingDesignBillingToggleActiveBackground]: {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'pricing-design-billing-toggle-discount-background': {
    dark: 'extended-7',
    light: 'extended-7',
  },
  'pricing-design-header-background': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'pricing-design-even-row-background': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'pricing-design-odd-row-background': {
    dark: 'primary-80',
    light: 'primary-80',
  },
  'pricing-design-footer-background': {
    dark: 'primary-40',
    light: 'primary-60',
  },
  'pricing-design-card-border': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-popular-border': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-popular-ring': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-badge-background': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-button-primary': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-button-secondary': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-background-type': {
    dark: 'solid',
    light: 'solid',
  },
  'pricing-design-card-background-solid': {
    dark: 'primary-80',
    light: 'primary-80',
  },
  'pricing-design-card-background-start-gradient': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-background-end-gradient': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-card-background-gradient-direction': {
    dark: 'primary-10',
    light: 'primary-90',
  },
  'pricing-design-column-background-opacity': {
    dark: '10',
    light: '10',
  },
}
